"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("./../utils");
var _classnames = _interopRequireDefault(require("classnames"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function BenefitComponent(props) {
  var _a = props || {},
    title = _a.title,
    content = _a.content,
    imageSrc = _a.imageSrc,
    href = _a.href,
    hrefText = _a.hrefText,
    filedVideoList = _a.filedVideoList,
    filedVideoBg = _a.filedVideoBg,
    videoExtendProps = _a.videoExtendProps,
    extendProps = _a.extendProps,
    record = _a.record;
  var imageSrcUrl = (0, _utils.fomateFileData)(imageSrc).url;
  var filedVideoListUrl = (0, _utils.fomateFileData)(filedVideoList).url;
  var postMessageUrl = record === null || record === void 0 ? void 0 : record.postMessageUrl;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-stories'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-stories-side'
  }, /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-stories-side-image', {
      'flex-default-stories-side-image-hover': filedVideoListUrl
    })
  }, videoExtendProps || {}, {
    onClick: function onClick() {
      if (filedVideoListUrl) {
        (0, _utils.reinitIframe)({
          filedVideoBg: filedVideoBg,
          filedVideoList: filedVideoList,
          postMessageUrl: postMessageUrl
        });
      }
    },
    style: {
      background: "url(" + imageSrcUrl + ")",
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  }), filedVideoListUrl ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'svg-scale'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'svg-filter'
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "60px",
    height: "60px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 114",
    className: "design-iconfont"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.0878099,30.0390178 L82.4381908,54.7230515 C82.8122427,54.9312371 82.9436418,55.3978303 82.7316792,55.7652167 C82.6622131,55.8856194 82.560778,55.9852469 82.4381908,56.0534751 L38.0878099,80.7375088 C37.7137579,80.9456943 37.2386992,80.8166367 37.0267364,80.4492504 C36.960414,80.3342966 36.9255533,80.2044243 36.9255533,80.072297 L36.9255533,30.7042296 C36.9255533,30.2819572 37.2740835,29.9396378 37.7040173,29.9396378 C37.8385418,29.9396378 37.9707706,29.9738775 38.0878099,30.0390178 Z",
    fill: "#FFF",
    transform: "translate(2.303823 2.61167)"
  })))))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-stories-side-content'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-stories-side-content-txt'
  }, title ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-stories-side-content-txt-article',
    dangerouslySetInnerHTML: {
      __html: title || ''
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-stories-side-content-txt-content', {
      'side-content-txt-content--height': !href
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'span',
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), href && ( /*#__PURE__*/_react["default"].createElement("a", __assign({
    href: href,
    className: 'flex-default-stories-side-content-txt-content-more'
  }, extendProps || {}), hrefText || 'Learn more', " >"))))));
}
var _default = exports["default"] = BenefitComponent;